let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k0u9s")).then(() => parcelRequire('ix6Ww'));